import { CIRCLES_API } from "../../config";
import * as ActionCreators from "./creators";
import { pushNotification } from "../ui_notifications/creators";
import fetchRetry from '../fetch_retry';
import { paramsToQueryString } from '../../utils/utils';

export function fetchRentalPrice(circleId, hours) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.fetchingRentalPrice());
    const url = `${CIRCLES_API}/prypool-products/${circleId}/rental_price/${hours}`;

    let request_options = {
      headers: { "Content-Type": "application/json" }
    }
    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        response => response.json(),
        error => {
          dispatch(ActionCreators.errorFetchingRentalPrice(error));
        }
      )
      .then(response => {
        if ('message' in response && response.message === "Internal Server Error") {
          dispatch(pushNotification("errors.bookings.fetch", "error"));
          dispatch(ActionCreators.errorFetchingRentalPrice(response.message));
        } else {
          dispatch(ActionCreators.fetchedRentalPrice(response, circleId));
        }
      },(error)=>{
        dispatch(ActionCreators.errorFetchingRentalPrice(error));
      })
  };
}

export function fetchBookings(productId, params) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.fetchingBookings());
    const { isRental, ...rest } = params;
    let url = `${CIRCLES_API}/booking/product/${productId}${paramsToQueryString(rest)}`;
    if (isRental) {
      url = `${CIRCLES_API}/prypool-products/${productId}/rental_availability${paramsToQueryString(rest)}`;
    }

    let request_options = {
      headers: { "Content-Type": "application/json" }
    }
    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        response => response.json(),
        error => {
          dispatch(ActionCreators.errorFetchingBookings(error));
        }
      )
      .then(response => {
        if ('message' in response && response.message === "Internal Server Error") {
          dispatch(pushNotification("errors.bookings.fetch", "error"));
          dispatch(ActionCreators.errorFetchingBookings(response.message));
        } else {
          dispatch(ActionCreators.fetchedBookings(response, productId, isRental));
        }
      });
  };
}

export function addBooking(payload, userId) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.addingNewBooking());
    let url = `${CIRCLES_API}/booking`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify(payload)
    }

    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    return new Promise((resolve, reject) => {
      fetchRetry(url, request_options, dispatch, getState)
        .then(
          response => response.json(),
          error => {
            dispatch(ActionCreators.errorAddingBooking(error));
          }
        )
        .then(response => {
          if ('message' in response) {
            if (response.message === "Internal Server Error") {
              dispatch(pushNotification("errors.bookings.add_booking", "error"));
              dispatch(ActionCreators.errorAddingBooking(response.message));
            } else if (response.error && (response.error === "MaxBookingDurationExceeded" || response.error === "MaxActiveBookingsExceeded")) {
              dispatch(pushNotification(`errors.bookings.${response.error}`, "error"));
              dispatch(ActionCreators.errorAddingBooking(response.error));
            }
          } else {
            dispatch(pushNotification("success.bookings.add_booking", "success"));
            dispatch(ActionCreators.addedNewBooking(response));
          }
        }).finally(_ => {
          resolve();
        });
    })

  };
}

export function deleteBooking(booking) {
  return function (dispatch, getState) {
    dispatch(ActionCreators.deletingBooking(booking));
    let url = `${CIRCLES_API}/booking/${booking.guid}`;

    let request_options = {
      headers: { "Content-Type": "application/json" },
      method: "DELETE"
    }

    if (getState().iam.accessToken) {
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        response => response.json(),
        error => {
          dispatch(ActionCreators.errorDeletingBooking(error));
        }
      )
      .then(response => {
        dispatch(pushNotification("success.bookings.delete_booking", "success"));
        dispatch(ActionCreators.deletedBooking(booking));
      });

  }
}